import {
  GET_DELIVERY_PROFILES,
  GET_DELIVERY_PROFILE,
  CREATE_DELIVERY_PROFILE,
  UPDATE_DELIVERY_PROFILE,
  DELETE_DELIVERY_PROFILE,
  DELIVERY_PROFILE_ERROR,
  SET_LOADING
} from '../actions/deliveryProfile';

const initialState = {
  deliveryProfiles: [],
  deliveryProfile: null,
  loading: false,
  error: null
};

export default function deliveryProfile(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_LOADING:
      return {
        ...state,
        loading: true
      };
    
    case GET_DELIVERY_PROFILES:
      return {
        ...state,
        deliveryProfiles: payload,
        loading: false
      };
    
    case GET_DELIVERY_PROFILE:
      return {
        ...state,
        deliveryProfile: payload,
        loading: false
      };
    
    case CREATE_DELIVERY_PROFILE:
      return {
        ...state,
        deliveryProfiles: [payload, ...state.deliveryProfiles],
        loading: false
      };
    
    case UPDATE_DELIVERY_PROFILE:
      return {
        ...state,
        deliveryProfiles: state.deliveryProfiles.map(profile =>
          profile._id === payload._id ? payload : profile
        ),
        deliveryProfile: payload,
        loading: false
      };
    
    case DELETE_DELIVERY_PROFILE:
      return {
        ...state,
        deliveryProfiles: state.deliveryProfiles.filter(profile => profile._id !== payload),
        deliveryProfile: state.deliveryProfile && state.deliveryProfile._id === payload ? null : state.deliveryProfile,
        loading: false
      };
    
    case DELIVERY_PROFILE_ERROR:
      return {
        ...state,
        error: payload,
        loading: false
      };
    
    default:
      return state;
  }
}
